
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discovery/[categoryId]",
      function () {
        return require("private-next-pages/discovery/[categoryId]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discovery/[categoryId]"])
      });
    }
  